import type { AdditionalInfo } from '@abb-procure/error-handling';
import type { BooleanInput } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  computed,
  inject,
  input,
  output,
} from '@angular/core';
import { EntityService } from '../../services/entity.service';
import { FormModeService } from '../../services/form-mode.service';
import { PageDeleted } from '../page-deleted/page-deleted.component';
import { PageHasError } from '../page-has-error/page-has-error.component';
import { PageMaintenanceMode } from '../page-maintenance-mode/page-maintenance-mode.component';
import { PageNotFound } from '../page-not-found/page-not-found.component';
import { PageNotVisible } from '../page-not-visible/page-not-visible.component';

@Component({
  selector: 'procure-page-container',
  templateUrl: './page-container.component.html',
  styleUrl: './page-container.component.scss',
  imports: [
    PageNotFound,
    PageNotVisible,
    PageMaintenanceMode,
    PageDeleted,
    PageHasError,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageContainer {
  readonly is404 = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly hasError = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly isInvisible = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly isDeleted = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly isInMaintenanceMode = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly errorDetails = input<AdditionalInfo | null>(null);

  readonly maintenanceText = input<string | null>(null);
  readonly redirectUrl = input<string>('/');
  readonly redirectLabel = input<string>('Go to Dashboard');

  readonly retry = output<void>();

  protected readonly formModeService = inject(FormModeService);
  protected readonly entityService = inject(EntityService);

  protected readonly showContent = computed(
    () =>
      !(
        this.is404() ||
        this.hasError() ||
        (this.isInvisible() && !this.formModeService.isAddMode()) ||
        this.isDeleted() ||
        this.isInMaintenanceMode()
      ),
  );
}
